"use strict";

angular.module("models").service("TelematicSyncConfigsService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("TelematicSyncConfigs", ["name"], function (element) {
    return "???";
  }));
}]);